// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"eadb7841","453":"55d06fc3","457":"dcbf07e7","551":"b3ecc6d2","638":"f292cf09","851":"7a612ecf"}[chunkId] + ".chunk.js";
};